import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mesh100-page',
  templateUrl: './mesh100-page.component.html',
  styleUrls: ['./mesh100-page.component.scss']
})
export class Mesh100PageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
